import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ImagePreviewModalProps {
    fileOrUrl: File | string | null;
    open: boolean;
    onClose: () => void;
}

export const ImagePreviewModal: React.FC<ImagePreviewModalProps> = ({
    fileOrUrl,
    open,
    onClose,
}) => {
    const [imageSrc, setImageSrc] = useState<string | null>(null);

    useEffect(() => {
        if (!fileOrUrl) return;

        if (typeof fileOrUrl === "string") {
            setImageSrc(fileOrUrl);
        } else {
            const objectUrl = URL.createObjectURL(fileOrUrl);
            setImageSrc(objectUrl);

            return () => URL.revokeObjectURL(objectUrl); // cleanup
        }
    }, [fileOrUrl]);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                Visualização da Imagem
                <IconButton
                    aria-label="fechar"
                    onClick={onClose}
                    sx={{ position: "absolute", right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                {imageSrc && (
                    <img
                        src={imageSrc}
                        alt="Pré-visualização"
                        style={{ width: "100%", maxHeight: "80vh", objectFit: "contain" }}
                    />
                )}
            </DialogContent>
        </Dialog>
    );
};